import React from 'react';

import { cssMap } from '@compiled/react';

import { Stack, type StackProps } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { ProjectItemSkeleton } from './ProjectItemSkeleton';

const styles = cssMap({
	projectItemList: {
		paddingTop: token('space.075'),
		paddingRight: token('space.200'),
		paddingLeft: token('space.200'),
		paddingBottom: token('space.075'),
	},
});

type ProjectListSkeletonProps = Omit<StackProps, 'children'> & {
	itemCount: number;
};

/**
 * Skeleton loader for a list of project items
 * @param itemCount - Number of skeleton items to display
 */
export const ProjectListSkeleton = ({
	itemCount,
	space = 'space.150',
	...stackProps
}: ProjectListSkeletonProps) => (
	<Stack xcss={styles.projectItemList} space={space} {...stackProps}>
		{Array.from({ length: itemCount }, (_, index) => (
			<ProjectItemSkeleton key={index} />
		))}
	</Stack>
);
